import { useContext } from "react";

import { CartMiniContext, type CartMiniContextProps } from "./CartMiniContext";

export const useCartMiniContext = (): CartMiniContextProps => {
  const context = useContext(CartMiniContext);
  if (!context) {
    throw new Error("useCartMiniContext used outside of CartMiniProvider");
  }
  return context;
};
